import { IXC_ORDERS_V1_ORDER_STATE_ENTITY_NAME } from '@interxfi/api-client/generated/entities/ixc-orders-v1-order-state';
import { Pill, type PillProps } from '@interxfi/design-system/components/pill/pill';
import { TranslatedText } from '@interxfi/translation/components/translated-text';
import type { IxcOrdersV1OrderStatus } from '@interxfi/types/generated/api';
import { getEntityVariant } from '../../util/entity-status-variants';

interface OrderStatusPillProps extends Omit<PillProps, 'children' | 'variant'> {
  status: IxcOrdersV1OrderStatus | undefined;
}

export function OrderStatusPill({ isPending, status, ...props }: OrderStatusPillProps) {
  return (
    <Pill isPending={!status || isPending} {...props} variant={getEntityVariant(IXC_ORDERS_V1_ORDER_STATE_ENTITY_NAME, status)}>
      <TranslatedText defaultValue={status} i18nKey={{ namespace: 'ixcOrdersV1', enumName: 'IxcOrdersV1OrderStatus', value: status }} />
    </Pill>
  );
}
